import React, { useRef } from 'react';
import { useLocalize } from 'localize-react';
import { IArticle, JourneyStatusType } from '@transferz/fe-models';
import { Card } from '@transferz/fe-component-library/src/components/card/Card';
import { PhoneRingIcon } from '@transferz/fe-component-library/src/components/icons';
import Accordion from '@transferz/fe-component-library/src/components/accordion/Accordion';
import { Button } from '@transferz/fe-component-library/src/components/button/Button';
import Typography from '@transferz/fe-component-library/src/components/typography/Typography';
import { QuestionMarkIcon } from '@transferz/fe-component-library/src/components/icons';
import { useQuerySection } from '../../../../queries/section/hooks/useQuerySection';
import { useQueryPhonesByCountry } from '../../../../queries/customerSupport/hooks/useQueryPhonesByCountry';
import './faq.scss';

interface IFAQProps {
  status: string;
  countryCode: string;
}

export const FAQ: React.FC<IFAQProps> = ({ status, countryCode }) => {
  const { translate, locale } = useLocalize();
  const customerServiceRef = useRef<any>();
  const { data: sectionData } = useQuerySection({
    variables: {
      id: 13013000402449,
      lng: locale.includes('en') ? 'en-gb' : locale,
    },
  });
  const { data: phonesByCountryData } = useQueryPhonesByCountry({
    variables: {
      params: {
        ...(countryCode && { countryCode }),
        contactType: 'TRAVELLER',
      },
    },
  });
  const articles = sectionData?.section?.section?.articles?.articles || [];
  const isCompleted = status === JourneyStatusType.JourneyInProgress
    || status === JourneyStatusType.Completed
    || status === JourneyStatusType.CancelledFree
    || status === JourneyStatusType.CancelledWithCosts;
  const isPending = status === JourneyStatusType.Pending;
  const isPlanned = status === JourneyStatusType.Planned
    || status === JourneyStatusType.Confirmed
    || status === JourneyStatusType.DriverArrived
    || status === JourneyStatusType.DriverUnderway;
  return (
    <div className={`faq ${isCompleted ? 'completed' : ''} ${isPending ? 'pending' : ''} ${isPlanned ? 'planned' : ''}`}>
      <Card
        title={translate('needHelp')}
        onCollapse={() => { }}
        collapsed={false}
        collapsibleIcon={false}
      >
        {
          articles?.map((article: IArticle) => (
            <Accordion
              key={article.id}
              nodeElement={<p dangerouslySetInnerHTML={{ __html: article.body }}></p>}
              title={article?.title}
              icon={<QuestionMarkIcon />}
            />
          ))
        }
        <div className="d-flex center support">
          <Typography color="dark" variant="body1">{translate('anotherQuestion')}</Typography>
          <Button
            priority="secondary"
            textColor="blue4"
            label={translate('callCustomerSupport')}
            icon={<PhoneRingIcon color="blue4" />}
            onClick={() => {
              customerServiceRef?.current?.click();
            }}
          />
          <a className="hidden"
            ref={customerServiceRef}
            href={`tel:${phonesByCountryData?.phonesByCountry[0]?.phoneNumber}`}>
          </a>
        </div>
      </Card>
    </div>
  );
};
